export const ResStatusIconUnknown: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="#F6A624" />
    <rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="white" />
    <path
      d="M5.22168 6.32245C5.22168 5.66418 5.85027 4.24654 8.14016 4.25C10.43 4.25347 10.778 5.93498 10.778 6.15399C10.778 8.4463 7.62381 7.7552 7.62381 10.6107"
      stroke="white"
      strokeWidth="1.5"
    />
    <rect
      x="7.19643"
      y="11.862"
      width="0.857142"
      height="0.642858"
      fill="white"
      stroke="white"
      strokeWidth="0.642858"
    />
  </svg>
);
